/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import { PLAY_STORE_URL, APP_STORE_URL } from './AppRedirect';
import '../styles/About.css';

function About() {
  return (
    <>
      <Header />

      {/* PAGE HEADER */}
      <div className="page-header">
        <div className="page-header-inner">
          <div className="page-eyebrow">
            <i className="ti ti-heart" style={{fontSize:'13px'}}></i> Our Story
          </div>
          <h1>We bring <em>fresh blooms</em><br />to your doorstep</h1>
          <p className="page-header-sub">Sadguru Flower was born in Morbi, Gujarat — from a simple belief that everyone deserves farm-fresh flowers, delivered fast and affordably.</p>
        </div>
      </div>

      {/* CONTENT */}
      <div className="ab-content">

        {/* INTRO CARD */}
        <div className="intro-card">
          <div className="intro-card-icon"><i className="ti ti-flower"></i></div>
          <p>
            <strong>Sadguru Flower is Gujarat's trusted floral delivery app.</strong> We connect flower lovers across Morbi, Rajkot, Jamnagar, and Halvad with farm-fresh bouquets, handcrafted varmalas, and curated gifts — all delivered the same day. Every order is packed with care, tracked in real time, and backed by a freshness guarantee.
          </p>
        </div>

        {/* STATS */}
        <div className="ab-stats">
          <div className="ab-stat-cell">
            <div className="ab-stat-num">10,000+</div>
            <div className="ab-stat-lbl">Happy customers</div>
          </div>
          <div className="ab-stat-cell">
            <div className="ab-stat-num">4.9 ★</div>
            <div className="ab-stat-lbl">App rating</div>
          </div>
          <div className="ab-stat-cell">
            <div className="ab-stat-num">4</div>
            <div className="ab-stat-lbl">Cities served</div>
          </div>
          <div className="ab-stat-cell">
            <div className="ab-stat-num">Same day</div>
            <div className="ab-stat-lbl">Order by 4 PM</div>
          </div>
        </div>

        {/* STORY */}
        <div className="story-section">
          <div className="section-eyebrow">Section 01</div>
          <h2>How Sadguru Flower started</h2>
          <p>
            It started with a simple frustration — finding truly fresh flowers in Morbi meant visiting crowded markets early in the morning, with no guarantee of quality or availability. The founder of Sadguru Flower wanted to change that. With a deep love for flowers and a drive to serve the local community, we built an app that brings the freshest blooms directly from Gujarat's farms to your front door.
          </p>
          <p>
            We launched with a small catalogue of bouquets and local delivery in Morbi, and quickly grew as customers fell in love with the freshness, the speed, and the simplicity of our app. Today we serve thousands of customers across 4 cities — from everyday gifting to grand wedding varmalas — and we're growing every month.
          </p>
          <p>
            Every flower on the Sadguru Flower app is sourced daily from trusted local farms. We work directly with growers to ensure that what you see is what you get — vibrant, long-lasting, and fragrant. No middlemen, no wilted stock.
          </p>
        </div>

        {/* VALUES */}
        <div className="values-section">
          <div className="section-eyebrow">Section 02</div>
          <h2>What we stand for</h2>
          <p className="section-sub">Three core values guide every decision we make — from how we source flowers to how we deliver them.</p>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon"><i className="ti ti-leaf"></i></div>
              <div className="value-title">Farm-fresh quality</div>
              <div className="value-desc">Every flower is sourced directly from local Gujarat farms and packed the same day. We never store overnight stock — freshness is non-negotiable.</div>
            </div>
            <div className="value-card">
              <div className="value-icon"><i className="ti ti-bolt"></i></div>
              <div className="value-title">Speed &amp; reliability</div>
              <div className="value-desc">Order before 4 PM, receive the same evening. We operate 7 days a week — 8 AM to 9 PM — with live order tracking so you always know where your blooms are.</div>
            </div>
            <div className="value-card">
              <div className="value-icon"><i className="ti ti-users"></i></div>
              <div className="value-title">Community roots</div>
              <div className="value-desc">We are proudly local. By partnering with Gujarat farmers and delivery partners, every order you place supports livelihoods in your own community.</div>
            </div>
            <div className="value-card">
              <div className="value-icon"><i className="ti ti-shield-check"></i></div>
              <div className="value-title">Trust &amp; transparency</div>
              <div className="value-desc">OTP login, no saved passwords, no hidden charges. Your data stays private and your payment is always secure — UPI, COD, or QR scan.</div>
            </div>
            <div className="value-card">
              <div className="value-icon"><i className="ti ti-crown"></i></div>
              <div className="value-title">Wedding excellence</div>
              <div className="value-desc">Our varmalas are hand-woven by skilled artisans. Every garland comes with full specs — weight, length, flower variety, and a 48-hour freshness guarantee.</div>
            </div>
            <div className="value-card">
              <div className="value-icon"><i className="ti ti-heart"></i></div>
              <div className="value-title">Packed with love</div>
              <div className="value-desc">Every order is hand-packed in eco-friendly hydrating sheets. We treat each delivery as if it's for our own family — because our customers deserve nothing less.</div>
            </div>
          </div>
        </div>

        {/* CITIES */}
        <div className="cities-section">
          <div className="section-eyebrow">Section 03</div>
          <h2>Where we deliver</h2>
          <p className="section-sub">We currently offer same-day delivery across 4 cities in Gujarat, with more coming soon.</p>
          <div className="city-chips">
            <div className="city-chip active"><i className="ti ti-map-pin"></i> Morbi — Headquarters</div>
            <div className="city-chip"><i className="ti ti-map-pin"></i> Rajkot</div>
            <div className="city-chip"><i className="ti ti-map-pin"></i> Jamnagar</div>
            <div className="city-chip"><i className="ti ti-map-pin"></i> Halvad</div>
            <div className="city-chip soon"><i className="ti ti-plus"></i> More cities coming soon</div>
          </div>
        </div>

        {/* DOWNLOAD CTA */}
        <div className="ab-cta">
          <div className="ab-cta-left">
            <h3>Download the Sadguru Flower app</h3>
            <p>Free to download · Same-day delivery · 7 days a week</p>
          </div>
          <div className="ab-cta-btns">
            <a className="ab-store-btn" href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
              <i className="ti ti-brand-apple"></i>
              <div>
                <span className="s1">Download on the</span>
                <span className="s2">App Store</span>
              </div>
            </a>
            <a className="ab-store-btn" href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
              <i className="ti ti-brand-google-play"></i>
              <div>
                <span className="s1">Get it on</span>
                <span className="s2">Google Play</span>
              </div>
            </a>
          </div>
        </div>

      </div>

      {/* FOOTER */}
      <footer className="ab-footer">
        <p>© 2026 Sadguru Flower. All rights reserved.</p>
        <div className="ab-footer-links">
          <Link to="/">Home</Link>
          <Link to="/privacy">Privacy policy</Link>
          <Link to="/contact">Contact us</Link>
        </div>
      </footer>
    </>
  );
}

export default About;
